import { AiFillDashboard } from "react-icons/ai";
import { BsForkKnife } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { MdCategory } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom"
import { auth } from "../Firebase";
import { useEffect } from "react";
import { LiaDumbbellSolid } from "react-icons/lia";

export default function AdminNavbar() {

    const navi = useNavigate();

    function logincheck() {
        auth.onAuthStateChanged((user) => {
            if (!user) {
                navi("/admin/")
            }
        })
    }

    useEffect(() => {
        logincheck();
    }, [])

    function logout() {
        auth.signOut().then(() => {
            navi("/admin/")
        }).catch((error) => {
            console.log("message");
            alert("Logout Failed");
        })
    }


    return (
        <>
            <div className="row m-0 bg-light p-3">
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top shadow">
                    <div className="container">
                        <Link className="navbar-brand fw-bold fs-3 text-danger">
                            <LiaDumbbellSolid className="text-danger mb-1 me-1" size={40} />Fitness App
                        </Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="adminNavbar">
                            <ul className="navbar-nav mx-auto gap-lg-2">
                                <li className="nav-item">
                                    <Link to="/admin/Dashboard" className="nav-link text-light px-3 py-2">
                                        <AiFillDashboard className="me-1" /> Dashboard
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/admin/Program" className="nav-link text-light px-3 py-2">
                                        <MdCategory className="me-1" /> Program
                                    </Link>
                                </li>
                                <li className="nav-item">
                                    <Link to="/admin/Enquiries" className="nav-link text-light px-3 py-2">
                                        <FaUsers className="me-1" /> Enquiries
                                    </Link>
                                </li>
                            </ul>
                            <div className="d-flex align-items-center gap-3">
                                <div className="dropdown">
                                    <button className="btn btn-dark border-secondary dropdown-toggle d-flex align-items-center gap-2" data-bs-toggle="dropdown">
                                        <div className="bg-warning text-dark rounded-circle d-flex justify-content-center align-items-center fw-bold" style={{ width: "35px", height: "35px" }}>
                                            A
                                        </div>
                                        <span className="text-light">Admin</span>
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-end">
                                        {/* <li>
                                            <Link to="/admin/AdminProfile" className="dropdown-item">👤 Profile</Link>
                                        </li> */}
                                        <li>
                                            <button onClick={logout} className="dropdown-item text-danger">🚪 Logout</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}